import Vue from 'vue'
import Vuex from 'vuex'
import { portalApi } from '../api/portalApi'
import { t } from '../i18n'
import { defaultPolicyField, defaultProcessSteps } from '../portalDefaults'

Vue.use(Vuex)

const LOCALE_KEY = 'portal-locale'

function supportedLocale(value) {
  return value === 'en' || value === 'zh' ? value : ''
}

function browserLocale() {
  const nav = window.navigator || {}
  const list = nav.languages && nav.languages.length ? nav.languages : [nav.language || '']
  for (let i = 0; i < list.length; i++) {
    const lang = String(list[i] || '').toLowerCase().split('-')[0]
    if (lang === 'zh' || lang === 'en') {
      return lang
    }
  }
  return 'zh'
}

function initialLocale() {
  return supportedLocale(localStorage.getItem(LOCALE_KEY)) || browserLocale()
}

export default new Vuex.Store({
  state: {
    locale: initialLocale(),
    brand: {
      brandNameZh: 'XTOOL',
      brandNameEn: 'XTOOL',
      primaryColor: '#1A8CFF',
      logoUrl: '',
      portalEnabled: 1,
      showLogo: 1,
      showName: 1,
      welcomeZh: '',
      welcomeEn: '',
      statementZh: '',
      statementEn: '',
      securityContact: '',
      hasPgpPublicKey: false,
      encryptReminder: ''
    },
    policy: {}
  },
  getters: {
    brandName(state) {
      return state.locale === 'en'
        ? (state.brand.brandNameEn || state.brand.brandNameZh)
        : (state.brand.brandNameZh || state.brand.brandNameEn)
    },
    welcome(state) {
      return state.locale === 'en' ? state.brand.welcomeEn : state.brand.welcomeZh
    },
    statement(state) {
      return state.locale === 'en' ? state.brand.statementEn : state.brand.statementZh
    },
    encryptReminder(state) {
      if (state.locale === 'en') {
        return state.brand.encryptReminderEn || t('en', 'encryptHint')
      }
      return state.brand.encryptReminderZh || state.brand.encryptReminder || t('zh', 'encryptHint')
    },
    hasPgpPublicKey(state) {
      const flag = state.brand && state.brand.hasPgpPublicKey
      if (flag === true || flag === 1 || flag === '1') {
        return true
      }
      const policyFlag = state.policy && state.policy.hasPgpPublicKey
      return policyFlag === true || policyFlag === 1 || policyFlag === '1'
    },
    pgpKeyId(state) {
      return (state.policy && state.policy.pgpKeyId) || (state.brand && state.brand.pgpKeyId) || ''
    },
    pgpFingerprint(state) {
      return (state.policy && state.policy.pgpFingerprint) || (state.brand && state.brand.pgpFingerprint) || ''
    },
    processSteps(state) {
      const fromPolicy = state.policy && state.policy.processSteps
      if (Array.isArray(fromPolicy) && fromPolicy.length) {
        return fromPolicy
      }
      const fromBrand = state.brand && state.brand.processSteps
      if (Array.isArray(fromBrand) && fromBrand.length) {
        return fromBrand
      }
      return defaultProcessSteps()
    },
    policyText(state) {
      return function (name) {
        const suffix = state.locale === 'en' ? 'En' : 'Zh'
        const other = suffix === 'En' ? 'Zh' : 'En'
        const policy = state.policy || {}
        return policy[name + suffix] || policy[name + other] || defaultPolicyField(name, state.locale)
      }
    },
    policyLines(state, getters) {
      return function (name) {
        const text = getters.policyText(name)
        if (!text) {
          return []
        }
        return text.split(/\r?\n/).map(function (line) {
          return line.trim()
        }).filter(Boolean)
      }
    }
  },
  mutations: {
    setLocale(state, locale) {
      state.locale = locale === 'en' ? 'en' : 'zh'
      localStorage.setItem(LOCALE_KEY, state.locale)
    },
    setBrand(state, brand) {
      state.brand = Object.assign({}, state.brand, brand || {})
    },
    setPolicy(state, policy) {
      state.policy = policy || {}
    }
  },
  actions: {
    loadBrand({ commit }) {
      return portalApi.brand().then((data) => {
        commit('setBrand', data)
        return data
      })
    },
    loadPolicy({ commit }) {
      return portalApi.policy().then((data) => {
        commit('setPolicy', data)
        return data
      })
    }
  }
})
